import { GeometryType, LayerDefinitionDc } from "@evergis/api";
import { isLayerService, LayerInfo } from "../../../interfaces/resourceInfo";
import { getAttributesConfiguration } from "./getAttributesConfiguration";

export const getLayerDefinition = (layer?: LayerInfo): LayerDefinitionDc => {
  const { geometryAttribute, idAttribute } = getAttributesConfiguration(layer);

  const emptyLayerDefinition: LayerDefinitionDc = {
    attributes: {},
    geometryAttribute,
    idAttribute,
    geometryType: GeometryType.Unknown,
    titleAttribute: "",
  };

  if (!isLayerService(layer) || !("layerDefinition" in layer)) {
    return emptyLayerDefinition;
  }

  return {
    ...emptyLayerDefinition,
    ...(layer.layerDefinition || {}),
    attributes: layer.layerDefinition.attributes || emptyLayerDefinition.attributes,
  };
};
